import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../../contexts/AuthContext'
import { HiOutlineArrowLeft, HiOutlineExclamationTriangle } from 'react-icons/hi2'

const WorkspaceBanner = () => {
  const navigate = useNavigate()
  const { ownerAccountName, clearWorkspace } = useAuth()

  const handleReturnToOwnAccount = () => {
    clearWorkspace()
    navigate('/dashboard')
  }

  return (
    <div className="workspace-banner flex items-center justify-between">
      <div className="flex items-center gap-3">
        <HiOutlineExclamationTriangle className="w-5 h-5" />
        <div>
          <span className="font-medium">
            You are managing {ownerAccountName}'s account
          </span>
          <span className="hidden sm:inline ml-2 opacity-90">
            • Limited dashboard view with recent sessions only
          </span>
        </div>
      </div>
      
      <button
        onClick={handleReturnToOwnAccount}
        className="flex items-center gap-2 px-3 py-1 bg-white/20 hover:bg-white/30 rounded-lg text-sm font-medium transition-colors"
      >
        <HiOutlineArrowLeft className="w-4 h-4" />
        <span className="hidden sm:inline">Return to My Account</span>
        <span className="sm:hidden">Return</span>
      </button>
    </div>
  )
}

export default WorkspaceBanner
